
import PageHeader from '@/components/PageStructure/PageHeader.vue';
import ProductAddonsList from '@/components/Product/ProductAddonsList.vue';
import ProductUpsellsContainer from '@/components/ProductUpsellsContainer.vue';
import {
  IonPage, IonFooter, IonContent, IonImg, IonCard,
  IonCardContent, IonCardHeader, IonCardSubtitle,
  IonCardTitle, IonSkeletonText, IonLabel, IonList,
  IonItem, IonItemDivider, IonItemGroup, IonButton,
  toastController
} from '@ionic/vue';
import { defineComponent, reactive } from 'vue';
import { getStoreProductBySlug, getStoreProducts } from '@/services/Api';
import cartModule from '@/store/modules/cart';
import { ProductAddonType, ProductType, CartItemAddonType, CartItemType } from "@/interfaces/types";
import { checkmarkDoneOutline, warningOutline } from "ionicons/icons";

export default defineComponent({
  name: 'Product',
  components: {
    ProductAddonsList, ProductUpsellsContainer, PageHeader,
    IonPage, IonFooter, IonContent, IonImg, IonCard,
    IonCardContent, IonCardHeader, IonCardSubtitle,
    IonCardTitle, IonSkeletonText, IonLabel, IonList,
    IonItem, IonItemDivider, IonItemGroup, IonButton,
  },
  props: ['category', 'slug'],
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    this.getProduct(this.$props.slug);
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  methods: {
    getProduct: function (slug: string) {
      getStoreProductBySlug(slug).then((data: ProductType[]) => {
        const product = data[0];
        this.product.data = product;

        this.prepareProductAddons(product.addons);

        getStoreProducts(product.upsell_ids).then((data) => this.product.upsells = data);
      });
    },
    prepareProductAddons: function (addons: ProductAddonType[]) {
      const addonsList: CartItemAddonType[] = [];

      addons.forEach((addon: ProductAddonType) => {
        const {id, label, type, options} = addon;

        if (type === 'checkbox') {
          const optionStatus: { label: string; selected: boolean }[] = options.label.map((label: string, index: number) => {
            return {label, selected: "default" in options && +options.default[0] === index}
          })
          addonsList.push({id: +id, label, type, options: optionStatus});
        } else if (type === 'radio') {
          addonsList.push({id: +id, label, type, options: options.label, selected: options.label[+options.default[0]]});
        }
      })

      addonsList.sort((a, b) => (a.id > b.id) ? 1 : -1);
      this.product.addons = addonsList;
    },
  },
  setup() {
    const reactiveData: { data: any; upsells: any; addons: CartItemAddonType[]; imageLoaded: boolean } = {
      data: {},
      upsells: [],
      addons: [],
      imageLoaded: false,
    }

    const product = reactive(reactiveData)

    async function openToast(message: string, error = false) {
      const header: string = error ? "Oops!" : "¡Genial!";
      const color: string | undefined = error ? "danger" : "success";
      const icon: string = error ? warningOutline : checkmarkDoneOutline;
      const toast = await toastController
        .create({
          message,
          header,
          color,
          translucent: false,
          position: "top",
          duration: 2000,
          buttons: [{
            side: "start",
            icon,
            role: "cancel",
          }]
        })
      return toast.present();
    }

    // TODO: [UI] Debounce this function (rdelcampo)
    function addToCart(id: number, name: string, price: string, image: string, description: string, addons: CartItemAddonType[]) {
      const cartObject: CartItemType = {
        id,
        price: +price,
        addons,
        meta: {
          name,
          description,
          image,
        }
      }

      cartModule.addToCart(cartObject).then(() => {
        openToast('El producto ha sido añadido al carrito.');
      }).catch((err) => {
        openToast(err || "Ha ocurrido un error inexperado.", true);
      });
    }

    return {
      addToCart,
      product,
    }
  },
})
